import { render, staticRenderFns } from "./AddSuper.vue?vue&type=template&id=0a327bee&scoped=true&"
import script from "./AddSuper.vue?vue&type=script&lang=js&"
export * from "./AddSuper.vue?vue&type=script&lang=js&"
import style0 from "./AddSuper.vue?vue&type=style&index=0&id=0a327bee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a327bee",
  null
  
)

export default component.exports